/** Emplacements WEB avec plusieurs slots par semaine (partage). */
export const WEB_SHARED_EMPLACEMENTS = new Set([
  'PAVE EDITO PARTAGE',
  'PAVE AGENDA PARTAGE',
]);

export function isWebSharedEmplacement(emplacement) {
  return WEB_SHARED_EMPLACEMENTS.has(String(emplacement ?? '').trim());
}
